import { AlertCircleIcon } from 'lucide-react';
import React, { useEffect } from 'react'
import { toast } from 'sonner';

const ConnectivityHandler = () => {
    useEffect(() => {
        const handleOnline = () => {
            toast.dismiss('ConnectivityHandler');
            //toast.success('Terug online', { duration: 3000 });
        };

        const handleOffline = () => {
            toast.custom((t) => (
            <div className='flex items-center gap-2 py-2 pl-3 pr-4 text-white rounded-md bg-black/80 backdrop-blur-lg'>
                <AlertCircleIcon className='w-4 h-4'/>
                <p className='text-sm'>Geen internetverbinding. Gelieve de pagina niet te herladen.</p>
            </div>
            ), {id:'ConnectivityHandler', duration:Infinity, position:'bottom-left'});
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Check the initial status
        if (!navigator.onLine) {
            handleOffline();
        }

        // Cleanup event listeners on component unmount
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

  return (
    <></>
  )
}

export default ConnectivityHandler